var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 7,
    fill: "#B1B1B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53466 20.2331C2.51366 17.5343 5.2003 16 8.07115 16H15.9289C18.7997 16 21.4863 17.5343 22.4653 20.2331C23.1638 22.1584 23.822 24.5515 23.9694 27.0005C24.0026 27.5518 23.5523 28 23 28H1C0.447716 28 -0.00257488 27.5518 0.0306018 27.0005C0.177983 24.5515 0.836213 22.1584 1.53466 20.2331Z",
    fill: "#B1B1B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBtn);
export default __webpack_public_path__ + "static/media/loginBtn.f43d7a98e080d870468bd40c8f32b03d.svg";
export { ForwardRef as ReactComponent };